import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import {PermissionsService} from "../../../../services/permissions/permissions.service";
import { AlertBannerService, AlertType } from 'src/app/lib/alert-banner';
interface Team {
  id: string;
  name: string;
  number_of_users: number;
  default_team: boolean;
  is_user_assigned: boolean
}

@Component({
  selector: 'app-manage-teams',
  templateUrl: './manage-teams.component.pug',
  styleUrls: ['./manage-teams.component.scss'],
  standalone: false
})
export class ManageTeamsComponent implements OnInit {
  readonly searchOptionsCore = [];
  @Input() selectedTeams: { [key: string]: Team } = {};
  NEW_USER = $localize`New User`
  @Input() newUser = false;
  @Output() userTeamsUpdated = new EventEmitter();

  get sortOptions() {
    return [
      {
        key: $localize`Team`,
        value: [
          { label: $localize`A-Z`, sortString: 'name' },
          { label: $localize`Z-A`, sortString: '-name' },
        ],
      },
      {
        key: 'group-end',
        value: []
      },
      {
        key: $localize`Users`,
        value: [
          { label: $localize`Oldest`, sortString: 'total_number_of_users' },
          { label: $localize`Newest`, sortString: '-total_number_of_users' },
        ],
      },
    ];
  }
  sortNewOptions = [
        {
            key: $localize`Team`,
            value: [
                {label: $localize`A-Z`, sortString: 'name'},
                {label: $localize`Z-A`, sortString: '-name'},
            ],
        },
        {
            key: 'group-end',
            value: []
        },
        {
            key: $localize`Users`,
            value : [
                  {label: $localize`Highest`, sortString: '-total_number_of_users'},
                  {label: $localize`Lowest`, sortString: 'total_number_of_users'},
            ]
        },
        ];

  pagination = {
    total: 50,
    rowsPerView: 20,
    currentPage: 1,
  };

  teams: Team[] = [];
  changedTeams = new Set<string>();
  disabledTeams: { [key: string]: Team } = {};
  sortString = 'name';
  searchString = '';
  loading = false;
  user: any = {};
  invitee: any = {};
  label = '';
  enabledTeams = 0;
  message = '';
  initialUserAssignedMapper = new Map<string, boolean>();
  newUserAssignedMapper = new Map<string, boolean>();
  isSaveButtonDisabled = false;
  requestTemplate = false;

  constructor(
    private bsModalRef: BsModalRef,
    private org: OrganisationService,
    private alertList: AlertBannerService,
    private permissions: PermissionsService,
  ) {
    this.requestTemplate = this.permissions.isFeatureActivated('ent-10605-request-templates');
  }

  ngOnInit(): void {
    if(this.requestTemplate){
        this.label = `${this.sortNewOptions[0].key} (${this.sortNewOptions[0].value[0].label})`;
    }
    else {
        this.label = `${this.sortOptions[0].key} (${this.sortOptions[0].value[0].label})`;
    }

    this.isSaveButtonDisabled = true;
    this.getPaginatedTeams();
  }

  loadTeams(offset, limit) {
    this.org
      .getTeams(offset, limit, this.sortString, this.searchString)
      .subscribe((data: any) => {
        {
          this.loading = false;
          if (data && data.data) {
            this.teams = data.data.teams.filter(team => team.default_team)
            .concat(data.data.teams.filter((team:any) => !team.default_team)) || [];
            this.teams.forEach(team => {
              if (!this.initialUserAssignedMapper.has(team.id)) {
                this.initialUserAssignedMapper.set(team.id, team.is_user_assigned);
              }
            });
            this.handleTeamsToggledState()
            this.pagination.total = data.data.total || 0;
            this.enabledTeams = Object.keys(this.selectedTeams).length;
          } else {
            this.teams = [];
            this.pagination.total = 0;
          }
        }
      }, (error) => {
        this.loading = false;
      });
  }

  handleTeamsToggledState() {
    this.teams = this.teams.map((team:any) =>{
      return {...team, is_user_assigned: this.selectedTeams[team.id] ? true : this.disabledTeams[team.id] ?  false : team.is_user_assigned};
    })
  }

  loadUserTeam(offset, limit) {
    this.org
      .getUserTeams(
        this.user.user_uid,
        offset,
        limit,
        this.sortString,
        this.searchString
      )
      .subscribe((data: any) => {
        {
          this.loading = false;
          if (data && data.data) {
            this.teams = data.data.teams.filter(team => team.default_team)
            .concat(data.data.teams.filter((team:any) => !team.default_team)) || [];
            this.teams.forEach(team => {
              if (!this.initialUserAssignedMapper.has(team.id)) {
                this.initialUserAssignedMapper.set(team.id, team.is_user_assigned);
              }
            });
            this.handleTeamsToggledState()
            this.pagination.total = data.data.total || 0;
            if (!(Object.keys(this.selectedTeams).length || Object.keys(this.disabledTeams).length))
              this.enabledTeams = data.data.enabled_teams || 0;
          } else {
            this.teams = [];
            this.pagination.total = 0;
          }
        }
      })
  }

  loadInviteeTeam(offset, limit) {
    this.org
      .getInviteeTeam(
        this.invitee.id,
        offset,
        limit,
        this.sortString,
        this.searchString
      )
      .subscribe((data: any) => {
        {
          this.loading = false;
          if (data && data.data) {
            this.teams = data.data.teams.filter(team => team.default_team)
            .concat(data.data.teams.filter((team:any) => !team.default_team)) || [];
            this.teams.forEach(team => {
              if (!this.initialUserAssignedMapper.has(team.id)) {
                this.initialUserAssignedMapper.set(team.id, team.is_user_assigned);
              }
            });
            this.handleTeamsToggledState()
            this.pagination.total = data.data.total || 0;
            if (!(Object.keys(this.selectedTeams).length || Object.keys(this.disabledTeams).length))
              this.enabledTeams = data.data.enabled_teams || 0;
          } else {
            this.teams = [];
            this.pagination.total = 0;
          }
        }
      })
  }

  getPaginatedTeams(): void {
    this.loading = true;
    const offset =
      (this.pagination.currentPage - 1) * this.pagination.rowsPerView;
    if (this.invitee.id) {
      this.loadInviteeTeam(offset, this.pagination.rowsPerView);
    } else if (this.user.user_uid) {
      this.loadUserTeam(offset, this.pagination.rowsPerView);
    } else {
      this.loadTeams(offset, this.pagination.rowsPerView);
    }
  }

  saveTeams(): void {
    if (this.enabledTeams == 0 || this.isSaveButtonDisabled) {
      return
    }
    const payload = {
      enabled_teams: Object.keys(this.selectedTeams).map((value) => Number(value)),
      disabled_teams: Object.keys(this.disabledTeams).map((value) => Number(value)),
    }
    if(this.user.user_uid && !this.newUser) {
      this.loading = true;
      this.org.updateUserTeam(this.user.user_uid, payload).subscribe(res => {
        this.loading = false;
        this.bsModalRef.hide();
        if (payload.enabled_teams.length || payload.disabled_teams.length) {
          this.userTeamsUpdated.emit(true);
        }
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! Changes have been saved.`,
          keepOnRouteChange: true
        }]);
      }, (error) => {
        this.loading = false;
      })
    } else if (this.invitee.id && !this.newUser) {
      this.loading = true;
      this.org.updateInviteeTeam(this.invitee.id, payload).subscribe(res => {
        this.loading = false;
        this.bsModalRef.hide();
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! Changes have been saved.`,
          keepOnRouteChange: true
        }]);
      }, (error) => {
        this.loading = false;
      })
    } else {
      this.message = 'confirm'
      this.bsModalRef.hide();
    }
  }

  cancel(): void {
    this.bsModalRef.hide();
  }

  onSearchEvent(event: any): void {
    this.searchString = event.search;
    this.getPaginatedTeams();
  }

  clearSearchResult(event) {
    this.searchString = '';
    this.getPaginatedTeams();
  }

  onSortChange(event: { sortString: string, key: string, label: string }): void {
    this.label = `${event.key} (${event.label})`;
    this.sortString = event.sortString;
    this.getPaginatedTeams();
  }

  departmentToggle(team: Team): void {
    team.is_user_assigned = !team.is_user_assigned;
    if (team.is_user_assigned) {
      this.selectedTeams[team.id] = team;
      if (this.disabledTeams[team.id]) delete this.disabledTeams[team.id];
      this.enabledTeams++;
    } else {
      delete this.selectedTeams[team.id];
      this.disabledTeams[team.id] = team;
      if(this.enabledTeams >0) this.enabledTeams--;
    }
    this.newUserAssignedMapper.set(team.id, team.is_user_assigned);
    let shouldDisableButton = true;

    // Enable/disable the save button if any value is different from initial mapper object
    for (const [key, value] of this.initialUserAssignedMapper) {
      if (!this.newUserAssignedMapper.has(key)) {
        continue;
      }
      if (this.newUserAssignedMapper.get(key) !== this.initialUserAssignedMapper.get(key)) {
        shouldDisableButton = false;
        break;
      }
    }
    this.isSaveButtonDisabled = shouldDisableButton;


  }

  onPageChange(event: number): void {
    this.pagination.currentPage = event;
    this.getPaginatedTeams();
  }

  onPageSizeChange(event: number): void {
    this.pagination.rowsPerView = event;
    this.getPaginatedTeams();
  }
}
